import PropTypes from 'prop-types';
import React from 'react';
import { bindAll } from '@bibliocommons/utils-react';
import { TextButton } from '@bibliocommons/deprecated-base-buttons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import '../styles/CatalogueResultItemButton.scss';

class CatalogueResultItemButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  handleClick() {
    if (this.props.handleClick) {
      this.props.handleClick();
    }
  }

  render() {
    const { label, screenReaderMessage, icon } = this.props;
    return (
      <div className="cp-catalogue-result-item-button">
        <TextButton className="btn-ugc item-button" dataKey="item-button" flat handleClick={this.handleClick}>
          {icon}
          <span aria-hidden>{label}</span>
          <ScreenReaderMessage>{screenReaderMessage}</ScreenReaderMessage>
        </TextButton>
      </div>
    );
  }
}

CatalogueResultItemButton.propTypes = {
  handleClick: PropTypes.func,
  icon: PropTypes.element,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  screenReaderMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export default CatalogueResultItemButton;
